import React from "react";
import { Breadcrumb, Button, Col, Form, Input, InputNumber, Layout, Modal, Row, Select, Switch, Typography, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { POST_API, getEnv, getToken, titleWeb } from "../../../../services/api";

// CONTROLLER
import Page403 from '../../../Controller/Page403';
import PageLoad from '../../../Controller/PageLoad';
import ReactInputMask from "react-input-mask";

import { ExclamationCircleOutlined } from '@ant-design/icons';

class Screen extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        _screen: true,
        _params: window.location.href.split('/'),
        defaultValue: null,
        type: false,
        address: {
            TOMADOR_LOGRADOURO: '',
            TOMADOR_NUMERO: '',
            TOMADOR_COMPLEMENTO: '',
            TOMADOR_BAIRRO: '',
            TOMADOR_MUNICIPIO: '',
            TOMADOR_UF: '',
        },
        products: [ ],
        openProduct: false,
        productValues: {},
        editProduct: -1,
        load: false,
        icms: ''
    }

    componentDidMount = async () => {
        titleWeb('NFSe')
        await POST_API('/nfse/filters.php', { token: getToken(), filter: JSON.stringify({ HABILITA_NFSE: 1 }) }).then(rs => rs.json()).then(res => {
            this.setState({_dados: res.data})
            if (this.props.type === 'add') {
                this.setState({_screen: false})
            } else if (this.props.type === 'edit') {
                this.onView()
            }
        })
    }

    onView = async () => {
        POST_API('/nfse/search.php', { token: getToken(), type: 'view', filter: JSON.stringify({ID: this.state._params[6]}) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({
                    defaultValue: res.data,
                    address: {
                        TOMADOR_LOGRADOURO: res.data.TOMADOR_LOGRADOURO,
                        TOMADOR_NUMERO: res.data.TOMADOR_NUMERO,
                        TOMADOR_COMPLEMENTO: res.data.TOMADOR_COMPLEMENTO,
                        TOMADOR_BAIRRO: res.data.TOMADOR_BAIRRO,
                        TOMADOR_MUNICIPIO: res.data.TOMADOR_MUNICIPIO,
                        TOMADOR_UF: res.data.TOMADOR_UF,
                    },
                    type: (res.data.TOMADOR_CNPJ != null && res.data.TOMADOR_CNPJ != '')
                })
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => {
            message.error({ content: 'Não foi possível estabelecer uma conexão com o sistema', key: 'screen' })
        }).finally(() => this.setState({_screen: false}))
    }

    onSend = (values) => {
        this.setState({_loading: true})

        values = {
            ...values,
            ...this.state.address
        }

        POST_API('/nfse/save.php', { token: getToken(), type: this.props.type, master: JSON.stringify(values), itens: JSON.stringify(this.state.products) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
                this.setState({_navigate: true})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => {
            message.error({ content: 'Não foi possível estabelecer uma conexão com o sistema', key: 'screen' })
        }).finally(() => this.setState({_loading: false}))
    }

    buscaCEP = async (val) => {
        var cep = String(val.target.value).replace('-', '')
        this.setState({cepload: true})
        await fetch('https://viacep.com.br/ws/'+cep+'/json/').then(rs => rs.json()).then(res => {
            if (res.erro) {
                message.warning('CEP inválido')
            } else {
                this.setState({
                    address: {
                        TOMADOR_LOGRADOURO: res.logradouro,
                        TOMADOR_BAIRRO: res.bairro,
                        TOMADOR_MUNICIPIO: res.localidade,
                        TOMADOR_UF: res.uf,
                    }
                })
            }
        }).catch(() => {
            message.warning('Não foi possível estabelecer uma conexão com o sistema')
        }).finally(() => this.setState({cepload: false}))

    }

    onAddProduct = () => {
        this.setState({ productValues: { NUMERO_ITEM: this.state.products.length+1 } })
        setTimeout(() => {
            this.setState({ openProduct: true })
        }, 500);
    }

    onEditProduct = (i) => {
        this.setState({ productValues: this.state.products[i], editProduct: i })
        setTimeout(() => {
            this.setState({ openProduct: true })
        }, 500);
    }

    onDelProduct = (i) => {
        var self = this
        Modal.confirm({
            title: 'Excluir produto?',
            icon: <ExclamationCircleOutlined />,
            cancelText: 'Não',
            okText: 'Sim',
            onOk() {
                self.setState({load: true})
                var list = self.state.products;
                list.splice(i, 1);

                list.map((v, i) => {
                    list[i].NUMERO_ITEM = i+1
                })

                self.setState({ products: list })
                setTimeout(() => {
                    self.setState({load: false})
                }, 1000);
            },
            onCancel() {},
        })
    }

    onSendProducts = (values) => {
        this.setState({load: true})
        var list = this.state.products;

        if (this.state.editProduct > -1) {
            list[this.state.editProduct] = values
        } else {
            values.key = values.NUMERO_ITEM;
            list.push(values)
        }

        this.setState({ products: list, productValues: {}, openProduct: false, editProduct: -1 })
        setTimeout(() => {
            this.setState({load: false})
        }, 1000);
    }

    render = () => {

        if (this.state._navigate) {
            return (<Navigate to={'/dashboard/fiscal/nfse'} />)
        }

        if (getToken() == null) {
            return (<Page403 />)
        }

        return (
            <Layout>
                <Layout.Content className={`${getEnv()}-container`}>
                    <Row gutter={[8,8]} align={'middle'}>
                        <Col span={18}>
                            <Breadcrumb>
                                <Breadcrumb.Item><Link to="/dashboard/fiscal">Documentos Fiscais</Link></Breadcrumb.Item>
                                <Breadcrumb.Item><Link to="/dashboard/fiscal/nfse">NFSe</Link></Breadcrumb.Item>
                                <Breadcrumb.Item>{ this.props.type === 'add' ? 'Novo' : 'Atualizar' }</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Link to={'/dashboard/fiscal/nfse'}><Button type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                        </Col>
                        { this.state._screen ? <PageLoad /> : (
                            <Col span={24}>
                                <Form layout="vertical" onFinish={this.onSend} initialValues={this.state.defaultValue}>
                                    <Form.Item hidden name="ID">
                                        <Input />
                                    </Form.Item>
                                    <Row gutter={[16,0]} className={`${getEnv()}-form`} style={{marginLeft: 0, marginRight: 0, marginBottom: 15}}>
                                        <Col span={24}>
                                            <Typography className="title_item">Dados Gerais</Typography>
                                            <div className="div_item_button">
                                                <Typography className="title_item_button">Carregar Venda</Typography>
                                            </div>
                                        </Col>
                                        <Col md={24} xs={24}>
                                            <Form.Item label="Empresa Emitente" name="FOCUSNFE_CONF_ID" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select style={{width: '100%'}}>
                                                    <Select.Option disabled>Selecione...</Select.Option>
                                                    { this.state._dados?.FOCUSNFE_CONF_ID.map((v, i) => (
                                                        <Select.Option key={i} value={v.value}>{v.text}</Select.Option>
                                                    )) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={10} xs={24}>
                                            <Form.Item label="Natureza da Operação" name="NATUREZA_OPERACAO" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select style={{width: '100%'}}>
                                                    <Select.Option disabled>Selecione...</Select.Option>
                                                    { this.state._dados?.NATUREZA_OPERACAO.map((v, i) => (
                                                        <Select.Option key={i} value={v.value}>{v.text}</Select.Option>
                                                    )) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={5} xs={24}>
                                            <Form.Item label="Optante Simples Nacional" name="OPTANTE_SIMPLES_NACIONAL" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select style={{width: '100%'}}>
                                                    <Select.Option disabled>Selecione...</Select.Option>
                                                    { this.state._dados?.OPTANTE_SIMPLES_NACIONAL.map((v, i) => (
                                                        <Select.Option key={i} value={v.value}>{v.text}</Select.Option>
                                                    )) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={5} xs={24}>
                                            <Form.Item label="Regime Especial Tributário" name="REGIME_ESPECIAL_TRIBUTARIO">
                                                <Select style={{width: '100%'}}>
                                                    <Select.Option disabled>Selecione...</Select.Option>
                                                    { this.state._dados?.REGIME_ESPECIAL_TRIBUTARIO.map((v, i) => (
                                                        <Select.Option key={i} value={v.value}>{v.text}</Select.Option>
                                                    )) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Incentivador Cultural" name="INCENTIVADOR_CULTURAL">
                                                <Select style={{width: '100%'}}>
                                                    <Select.Option disabled>Selecione...</Select.Option>
                                                    { this.state._dados?.INCENTIVADOR_CULTURAL.map((v, i) => (
                                                        <Select.Option key={i} value={v.value}>{v.text}</Select.Option>
                                                    )) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={5} xs={24}>
                                            <Form.Item label="Data Emissão" name="DATA_EMISSAO" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input type="date" />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Código Obra" name="CODIGO_OBRA">
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={3} xs={24}>
                                            <Form.Item label="Artigo" name="ART">
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Nº RPS Substuído" name="NUMERO_RPS_SUBSTITUIDO">
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Série RPS Substuído" name="SERIE_RPS_SUBSTITUIDO">
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Tipo RPS Substuído" name="TIPO_RPS_SUBSTITUIDO">
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={[16,0]} className={`${getEnv()}-form`} style={{marginLeft: 0, marginRight: 0, marginBottom: 15}}>
                                        <Col span={24}>
                                            <Typography className="title_item">Tomador</Typography>
                                            <div className="div_item_button">
                                                <Typography className="title_item_button">Carregar Cliente</Typography>
                                            </div>
                                        </Col>
                                        <Col xs={24} md={5}>
                                            <Form.Item label={ this.state.type ? "CNPJ" : "CPF" } name={ this.state.type ? "TOMADOR_CNPJ" : "TOMADOR_CPF" } rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <ReactInputMask mask={ this.state.type ? "99.999.999/9999-99" : "999.999.999-99" }>
                                                    {(inputProps) => <Input {...inputProps} /> }
                                                </ReactInputMask>
                                            </Form.Item>
                                            <Switch checked={this.state.type} onChange={(v) => this.setState({type: v})} style={{position: 'absolute', right: 12, top: 35}} checkedChildren='PJ' unCheckedChildren='PF' />
                                        </Col>
                                        <Col xs={24} md={9}>
                                            <Form.Item label={ this.state.type ? "Razão Social" : "Nome" } name="TOMADOR_RAZAO_SOCIAL" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input type='text' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <Form.Item label="E-mail" name="TOMADOR_EMAIL">
                                                <Input type='text' />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={4}>
                                            <Form.Item label="Telefone" name="TOMADOR_TELEFONE">
                                                <ReactInputMask mask={"(99) 99999-9999"}>
                                                    {(inputProps) => <Input {...inputProps} /> }
                                                </ReactInputMask>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={3}>
                                            <Form.Item label="CEP" name="TOMADOR_CEP">
                                                <ReactInputMask mask={'99999-999'} onBlur={this.buscaCEP}>
                                                    {(inputProps) => <Input {...inputProps} /> }
                                                </ReactInputMask>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={17}>
                                            <Form.Item label="Logradouro">
                                                <Input type='text' value={this.state.address.TOMADOR_LOGRADOURO} onChange={(v) => this.setState({ address: { ...this.state.address, TOMADOR_LOGRADOURO: v.target.value } })} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={4}>
                                            <Form.Item label="Número">
                                                <Input type='text' value={this.state.address.TOMADOR_NUMERO} onChange={(v) => this.setState({ address: { ...this.state.address, TOMADOR_NUMERO: v.target.value } })} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <Form.Item label="Complemento">
                                                <Input type='text' value={this.state.address.TOMADOR_COMPLEMENTO} onChange={(v) => this.setState({ address: { ...this.state.address, TOMADOR_COMPLEMENTO: v.target.value } })} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={10}>
                                            <Form.Item label="Bairro">
                                                <Input type='text' value={this.state.address.TOMADOR_BAIRRO} onChange={(v) => this.setState({ address: { ...this.state.address, TOMADOR_BAIRRO: v.target.value } })} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={6}>
                                            <Form.Item label="Município">
                                                <Input type='text' value={this.state.address.TOMADOR_MUNICIPIO} onChange={(v) => this.setState({ address: { ...this.state.address, TOMADOR_MUNICIPIO: v.target.value } })} />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={2}>
                                            <Form.Item label="UF">
                                                <Input type='text' maxLength={2} value={this.state.address.TOMADOR_UF} onChange={(v) => this.setState({ address: { ...this.state.address, TOMADOR_UF: v.target.value } })} />
                                            </Form.Item>
                                        </Col>                                        
                                    </Row>
                                    <Row gutter={[16,0]} className={`${getEnv()}-form`} style={{marginLeft: 0, marginRight: 0, marginBottom: 15}}>
                                        <Col span={24}>
                                            <Typography className="title_item">Serviço</Typography>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Valor Serviço" name='SERVICO_VALOR_SERVICOS' rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Valor Deduções" name='SERVICO_VALOR_DEDUCOES'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Valor PIS" name='SERVICO_VALOR_PIS'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Valor COFINS" name='SERVICO_VALOR_COFINS'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Valor INSS" name='SERVICO_VALOR_INSS'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Valor IR" name='SERVICO_VALOR_IR'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Valor CSLL" name='SERVICO_VALOR_CSLL'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={3} xs={24}>
                                            <Form.Item label="ISS Retido" name="SERVICO_ISS_RETIDO" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Select style={{width: '100%'}}>
                                                    <Select.Option disabled>Selecione...</Select.Option>
                                                    { this.state._dados?.SERVICO_ISS_RETIDO.map((v, i) => (
                                                        <Select.Option key={i} value={v.value}>{v.text}</Select.Option>
                                                    )) }
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Valor ISS" name='SERVICO_VALOR_ISS'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Valor ISS Retido" name='SERVICO_VALOR_ISS_RETIDO'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Outras Retencões" name='SERVICO_OUTRAS_RETENCOES'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={3} xs={24}>
                                            <Form.Item label="Base Cálculo" name='SERVICO_BASE_CALCULO'>
                                                <InputNumber style={{width: '100%'}} decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={2} xs={24}>
                                            <Form.Item label="Alíquota" name='SERVICO_ALIQUOTA'>
                                                <InputNumber style={{width: '100%'}} decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Desc. Incondicionado" name='SERVICO_DESCONTO_INCONDICIONADO'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Desc. Condicionado" name='SERVICO_DESCONTO_CONDICIONADO'>
                                                <InputNumber addonBefore='R$' decimalSeparator="," />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Item Lista Serviço" name='SERVICO_ITEM_LISTA_SERVICO' rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Código CNAE" name='SERVICO_CODIGO_CNAE'>
                                                <ReactInputMask mask={'9999999'}>
                                                    {(inputProps) => <Input {...inputProps} /> }
                                                </ReactInputMask>
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Cód. Trib. Município" name='SERVICO_CODIGO_TRIBUTARIO_MUNICIPIO'>
                                                <Input />
                                            </Form.Item>
                                        </Col>
                                        <Col md={4} xs={24}>
                                            <Form.Item label="Código Município" name='SERVICO_CODIGO_MUNICIPIO' rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <ReactInputMask mask={'9999999'}>
                                                    {(inputProps) => <Input {...inputProps} /> }
                                                </ReactInputMask>
                                            </Form.Item>
                                        </Col>
                                        <Col md={24} xs={24}>
                                            <Form.Item label="Discriminação" name="SERVICO_DISCRIMINACAO" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                <Input.TextArea rows={3} />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Button loading={this.state._loading} htmlType="submit" type="primary" shape="round" className="float-right">Salvar</Button>
                                </Form>
                            </Col>
                        ) }
                    </Row>
                </Layout.Content>
            </Layout>
        )

    }

}

export default Screen;